import React, { useState, useEffect } from 'react';
import { api } from '../services/api';

export const ServerStatus = () => {  
  const [heartbeat, setHeartbeat] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const checkHeartbeat = async () => {
      try {
        const data = await api.getHeartbeat();
        if (isMounted) {
          const lastMessageTime = new Date(data.lastMessageTimestamp).getTime();
          const SecondsAgo = Date.now() - 61000;
          
          setHeartbeat({
            lastMessageTimestamp: data.lastMessageTimestamp,
            status: lastMessageTime > SecondsAgo ? 'active' : 'inactive'
          });
        }
      } catch (error) {
        if (isMounted) {
          setHeartbeat({
            status: 'inactive',
            lastMessageTimestamp: null
          });
        }
      }
    };

    checkHeartbeat();
    const interval = setInterval(checkHeartbeat, 5000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);


  return (
    <div className="bg-white rounded-lg shadow-sm p-3 flex items-center gap-4">
      <div className="flex items-center gap-2">
        <div className={`w-2 h-2 rounded-full ${
          heartbeat?.status === 'active' ? 'bg-green-500' : 'bg-red-500'
        }`} />
        <span className="text-sm font-medium">
          {heartbeat?.status === 'active' ? 'Active' : 'Inactive'}
        </span>
      </div>
    </div>
  );
};